/**
 * A HOC wrapping Material UIs TableHead component. Used to unify styles across
 * all of our tables
 */
import { isEmpty } from 'lodash';
import React from 'react';
import { withStyles } from 'tss-react/mui';
import { TableHead } from '@mui/material';

const styles = (theme) => {
  if (isEmpty(theme)) return {};

  return {
    root: {
      height: '20px',
      backgroundColor: '#0a0908',
      [theme.breakpoints.up('sm')]: {
        height: '35px',
      },
    },
  };
};

export default withStyles((props) => {
  const { classes } = props;
  return <TableHead className={classes.root} {...props} />;
}, styles);
